import VerifyBanner from './VerifyBanner';

export default VerifyBanner;
